import {
  Box,
  Button,
  chakra,
  Container,
  Divider,
  Flex,
  HStack,
  Image,
  shouldForwardProp,
  Text,
  useBoolean,
  VStack,
} from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import { digit } from "lib/utils/digit";

const AnimateBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

interface IPriceBoxProps {
  isLoading: boolean;
  isDisabled: boolean;
  carePrice: number;
  repairPrice: number;
  enhancePrice: number;
  onSaveProduct: () => void;
}

function PriceBox(props: IPriceBoxProps) {
  const [flagPriceBox, setFlagPriceBox] = useBoolean();
  const gotoChat = () => {
    const channel = localStorage.getItem("channel");
    if (channel === "bybtheh") {
      window.open("http://pf.kakao.com/_zsiQxj/chat", "_blank");
    } else if (channel === "smcare") {
      window.open("http://pf.kakao.com/_clxbxmK/chat", "_blank");
    } else {
      window.open("http://pf.kakao.com/_Nsvixj/chat", "_blank");
    }
  };
  return (
    <Container
      position={"fixed"}
      maxW={"768px"}
      minW={"320px"}
      bottom={0}
      w="100%"
      h="137px"
      px={0}
      zIndex="modal"
    >
      <Box position={"relative"} w="full" h="full">
        {/* -17 ~ -101 */}
        <AnimateBox
          position="absolute"
          w="full"
          h="106px"
          top={"-17px"}
          zIndex={-1}
          animate={{ y: flagPriceBox ? -88 : 0 }}
          /*// @ts-ignore */
          transition={{
            duration: 0.3,
            ease: "easeInOut",
          }}
        >
          <Box
            w={"full"}
            h="16px"
            position={"relative"}
            justifyContent="center"
            alignItems="center"
          >
            <Flex
              bg="white"
              position="absolute"
              w="46px"
              h="100%"
              top={"1px"}
              left={0}
              right={0}
              mx="auto"
              borderTop="1px"
              borderLeft="1px"
              borderRight="1px"
              roundedTop={"4px"}
              borderColor={"#eeeeee"}
              justifyContent="center"
              alignItems={"center"}
              style={{ boxShadow: "0px -1px 3px #eeeeee" }}
              onClick={setFlagPriceBox.toggle}
              fontSize="14px"
            >
              {flagPriceBox ? "↓" : "↑"}
            </Flex>
          </Box>
          <Box
            w="full"
            h={"90px"}
            bg="white"
            borderTop={"1px"}
            borderColor={"#eeeeee"}
            style={{ boxShadow: "0px -1px 3px #eeeeee" }}
            px="20px"
            fontSize={"14px"}
            fontWeight={"medium"}
          >
            <VStack spacing={"3px"} mt={"13px"} justifyContent="center">
              <HStack w={"full"} justifyContent="space-between">
                <Text color="#757575">관리</Text>
                <Text color="#212121">{digit(props.carePrice)}원</Text>
              </HStack>
              <HStack w={"full"} justifyContent="space-between">
                <Text color="#757575">복원</Text>
                <Text color="#212121">{digit(props.repairPrice)}원</Text>
              </HStack>
              <HStack w={"full"} justifyContent="space-between">
                <Text color="#757575">보강</Text>
                <Text color="#212121">{digit(props.enhancePrice)}원</Text>
              </HStack>
            </VStack>
            <Divider mt={"5px"} />
          </Box>
          <Box
            w={"68px"}
            h={"68px"}
            position={"absolute"}
            top={"-68px"}
            right={"16px"}
            onClick={gotoChat}
          >
            <Image src="/assets/images/kakao_68x68.svg" />
          </Box>
        </AnimateBox>
        <Box w={"100%"} h={"100%"} bg="white" px={"20px"}>
          <HStack
            w="100%"
            h="51px"
            justifyContent={"space-between"}
            fontSize="16px"
            fontWeight={"semibold"}
          >
            <Text>총 서비스 금액</Text>
            <HStack gap={"12px"}>
              {localStorage.getItem("channel") === "smcare" &&
                props.carePrice + props.repairPrice + props.enhancePrice >
                  0 && (
                  <Text textDecoration="line-through" color={"#ff375f"}>
                    {digit(
                      Math.floor(
                        ((props.carePrice +
                          props.repairPrice +
                          props.enhancePrice) /
                          70.0) *
                          100.0
                      )
                    )}
                  </Text>
                )}
              <Text>
                {digit(
                  props.carePrice + props.repairPrice + props.enhancePrice
                )}
                원
              </Text>
            </HStack>
          </HStack>
          <Flex w="100%" h="86px" alignItems={"center"}>
            <Button
              isLoading={props.isLoading}
              isDisabled={props.isDisabled}
              colorScheme={"mint"}
              w="100%"
              h={"50px"}
              fontSize={"16px"}
              fontWeight="semibold"
              onClick={props.onSaveProduct}
            >
              제품 저장하기
            </Button>
          </Flex>
        </Box>
      </Box>
    </Container>
  );
}

export default PriceBox;
